export default "__VITE_ASSET__D0D48jk4__"